import Service from "../../Services";

const Services = {
  namespaced: true,
  state: {
    form: {
      orders: "",
      service_id: "",
      branch_id: "",
      title_th: "",
      title_en: "",
      description_th: "",
      description_en: "",
      slug_url: "",
      icon: "",
      icon_show: "",
      is_publish: true
    }
  },
  mutations: {
    GET_FORM_SERVICE: (state, res) => {
      state.form = res;
    },
    CLEAR_FORM_DATA: state => {
      state.form = {
        orders: "",
        service_id: "",
        branch_id: "",
        title_th: "",
        title_en: "",
        description_th: "",
        description_en: "",
        slug_url: "",
        icon: "",
        is_publish: true,
        icon_show: ""
      };
    }
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getService({ commit }, page) {
      return Service.ServiceAPI.getService(page);
    },
    // eslint-disable-next-line no-unused-vars
    showService({ commit }, id) {
      return Service.ServiceAPI.showService(id);
    },
    // eslint-disable-next-line no-unused-vars
    saveService({ commit }, { id, data }) {
      if (id) {
        // update
        return Service.ServiceAPI.updateService(id, data);
      }
      // create
      return Service.ServiceAPI.createService(data);
    },
    // eslint-disable-next-line no-unused-vars
    deleteService({ commit }, id) {
      return Service.ServiceAPI.deleteService(id);
    },
    // eslint-disable-next-line no-unused-vars
    getServiceAll({ commit }) {
      return Service.ServiceAPI.getServiceAll();
    },
    // eslint-disable-next-line no-unused-vars
    getServiceByBranch({ commit }, branch_id) {
      return Service.ServiceAPI.getServiceByBranch(branch_id);
    },
    setFormService({ commit }, res) {
      commit("GET_FORM_SERVICE", res);
    },
    clearFormData({ commit }) {
      commit("CLEAR_FORM_DATA");
    }
  }
};
export default Services;
